import React from 'react';
import COLORS from 'shared/design-tokens/colors';

// Multi-color document icon (file-type badge), so it takes no `color` prop.
export const FileXlsIcon = ({
  width = '24',
  height = '24',
  'aria-hidden': ariaHidden = true,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={ariaHidden}
    {...rest}
  >
    <path
      d="M7.5 1.75h8L20.25 6.5V20a2.25 2.25 0 0 1-2.25 2.25H7.5A2.25 2.25 0 0 1 5.25 20V4A2.25 2.25 0 0 1 7.5 1.75Z"
      fill={COLORS.white}
      stroke={COLORS.neutral300}
      strokeWidth="1.5"
    />
    <path
      d="M15.5 1.75V5a1.5 1.5 0 0 0 1.5 1.5h3.25"
      stroke={COLORS.neutral300}
      strokeWidth="1.5"
    />
    <rect
      x="1.5"
      y="11"
      width="15"
      height="8"
      rx="1.5"
      fill={COLORS.success450}
    />
    <text
      x="9"
      y="17.1"
      textAnchor="middle"
      fontFamily="Manrope, sans-serif"
      fontSize="6.2"
      fontWeight="700"
      fill={COLORS.white}
    >
      XLS
    </text>
  </svg>
);
